import React from "react";
import {SelectId} from "./SelectId";

const PBROptions = [
    { id: null, label: 'None' },
    { id: 'panel_only', label: 'Panel Only' },
    { id: 'slot_only', label: 'Slot Only' },
    { id: 'unbookable', label: 'Unbookable' }
];

export const PanelBookingRestrictionIdSelect = (props) => {
    return <SelectId options={PBROptions} {...props} labelField="label" />;
}

